import React from 'react';
import styled from 'styled-components';
import Tooltip from '@material-ui/core/Tooltip';

export const TooltipStyled = styled(({ className, ...props }) => (
  <Tooltip
    classes={{ popper: className }}
    arrow={true}
    placement='bottom-end'
    enterTouchDelay={0}
    leaveTouchDelay={10000}
    {...props}
  />
))(({ color }) => ({
  [`& .MuiTooltip-tooltip`]: {
    width: 320,
    padding: 12,
    fontSize: 14,
    opacity: 1,
    backgroundColor: color,
    boxShadow: `0px 4px 6px -2px rgba(16, 24, 40, 0.03),
        0px 12px 16px -4px rgba(16, 24, 40, 0.08)`,
  },
  [`& .MuiTooltip-arrow`]: {
    color,
  },
}));
